export default __webpack_public_path__ + "static/media/glrc-course.plant-based-cooking-method.0a1d887b.png";